<template>
    <div class="search_item mb19">
        <div class="search_input detection_search_input">
            <el-input :placeholder="$t('st')" v-model="searchInput"
                      @keypress.enter.native="setFilterFunc('ni',searchInput)"/>
            <button class="search_btn mypage_search_btn" @click="setFilterFunc('ni',searchInput)">
            </button>
        </div>
        <button class="search_filter_btn" @click="openFilter('member-filter-creator-filter')"></button>
        <member-filter-creator-filter></member-filter-creator-filter>
    </div>
</template>

<script>
import memberUtil from "@/components/member/memberUtil";
import MemberFilterCreatorFilter from "@/components/filter/MemberFilterCreatorFilter";

const {filterConfig} = memberUtil
export default {
    name: "MemberFilterInterestCreatorLayout",
    mixins: [],
    components: {MemberFilterCreatorFilter},
    inject: ['setFilter', 'setSort'],
    provide() {
        return {}
    },
    props: {
        filterData: {
            default: () => {
            }
        },
        filterSet: {default: {filter: {}, page: {page: 1, size: 1, total: 0}, sort: {}}}
    },
    data() {
        return {
            searchOption: 'ina',
            sortOption: 'i.updated_at',
            searchInput: '',
            filterType: [],
            filterCurator: [],
            filterLike: ["", ""],
            filterItem: ["", ""],
            tab: '',
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.setterFilterDataInData();
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        openFilter(name) {
            this.$modal.show(name, {filterData: this.filterData, filterSet: this.filterSet});
        },
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    // this[classname] =
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        this[classname] = [obj.start, obj.end];
                    } else if (type === 'match') {
                        if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    } else if (type === 'terms') {
                        this[classname] = obj.terms;
                    }

                }
            })
        },
        changeFilterItem() {
            if (this.filterItem[1] !== '' && this.filterItem[0] > this.filterItem[1]) {
                return
            }
            this.setFilterFunc('itc', this.filterItem);
        },
        changeFilterLike() {
            if (this.filterLike[1] !== '' && this.filterLike[0] > this.filterLike[1]) {
                return
            }
            this.setFilterFunc('lic', this.filterLike);
        },
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },
        setData(key, value) {
            this[key] = value;
        },
        openModal(name) {
            this.$modal.show(name);
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
